export const mapNodes = {
  Bucuresti: { x: 384.73, y: 365.97 },
  Buzau: { x: 411.24, y: 300.09 },
  Cluj: { x: 206.32, y: 152.58 },
  Constanta: { x: 515.45, y: 381.57 },
  Craiova: { x: 207.53, y: 391.98 },
  "Miercurea – Ciuc": { x: 336.77, y: 180.71 },
  Oradea: { x: 120.83, y: 136.41 },
  Orastie: { x: 170.98, y: 256.26 },
  Neamt: { x: 385.07, y: 132.41 },
  "Valea Chioarului": { x: 158.73, y: 70.76 },
  // legatura
  Alba: { x: 190, y: 210 },
  Maramures: { x: 230.65, y: 63.46 },
  Gorj: { x: 210, y: 330 },
  Dambovita: { x: 340, y: 340 },
  Arges: { x: 300, y: 360 },
  Olt: { x: 250, y: 370 },
  Calarasi: { x: 440.11, y: 388.48 },

  Prahova: { x: 358.1, y: 301.26 },
  Brasov: { x: 330.47, y: 254.39 },
  Covasna: { x: 363.89, y: 234.84 },

  Ialomita: { x: 427.63, y: 361.42 },
  Vrancea: { x: 440.03, y: 271.23 },
  Bacau: { x: 418.13, y: 204.14 },
};

export const zones = [
  "BUC",
  "BZU",
  "CLJ",
  "CTA",
  "CRV",
  "MRC",
  "BIH",
  "ORS",
  "RMN",
  "VCH",
];

export const deliveryDaysMatrix = {
  BUC: {
    BUC: "0 - 1",
    BZU: "1",
    CLJ: "1",
    CTA: "3",
    CRV: "2",
    MRC: "1",
    BIH: "1",
    ORS: "2",
    RMN: "3",
    VCH: "3",
  },
  BZU: {
    BUC: "1",
    BZU: "0 - 1",
    CLJ: "2",
    CTA: "3",
    CRV: "1",
    MRC: "2",
    BIH: "2",
    ORS: "3",
    RMN: "2",
    VCH: "2",
  },
  CLJ: {
    BUC: "2",
    BZU: "2",
    CLJ: "0 - 1",
    CTA: "2",
    CRV: "3",
    MRC: "2",
    BIH: "1",
    ORS: "3",
    RMN: "3",
    VCH: "2",
  },
  CTA: {
    BUC: "1",
    BZU: "2",
    CLJ: "1",
    CTA: "0 - 1",
    CRV: "2",
    MRC: "1",
    BIH: "3",
    ORS: "3",
    RMN: "3",
    VCH: "1",
  },
  CRV: {
    BUC: "1",
    BZU: "3",
    CLJ: "2",
    CTA: "1",
    CRV: "0 - 1",
    MRC: "3",
    BIH: "3",
    ORS: "2",
    RMN: "2",
    VCH: "3",
  },
  MRC: {
    BUC: "1",
    BZU: "1",
    CLJ: "1 - 2",
    CTA: "1",
    CRV: "1",
    MRC: "0 - 1",
    BIH: "1 - 2",
    ORS: "1 - 2",
    RMN: "1",
    VCH: "1 - 2",
  },
  BIH: {
    BUC: "2 - 3",
    BZU: "2 - 3",
    CLJ: "0 - 1",
    CTA: "2 - 3",
    CRV: "1 - 2",
    MRC: "2 - 3",
    BIH: "0 - 1",
    ORS: "1",
    RMN: "2 - 3",
    VCH: "1 - 2",
  },
  ORS: {
    BUC: "2",
    BZU: "2",
    CLJ: "1",
    CTA: "3",
    CRV: "3",
    MRC: "1",
    BIH: "1",
    ORS: "0 - 1",
    RMN: "2",
    VCH: "1",
  },
  RMN: {
    BUC: "1",
    BZU: "2",
    CLJ: "2",
    CTA: "3",
    CRV: "3",
    MRC: "2",
    BIH: "1",
    ORS: "2",
    RMN: "0 - 1",
    VCH: "2",
  },
  VCH: {
    BUC: "2 - 3",
    BZU: "2 - 3",
    CLJ: "1 - 2",
    CTA: "2 - 3",
    CRV: "1 - 2",
    MRC: "2 - 3",
    BIH: "1 - 2",
    ORS: "1 - 2",
    RMN: "2 - 3",
    VCH: "0 - 1",
  },
};

export const coveringData = [
  {
    nod: "Bucuresti",
    zona: "BUC",
    arie: "Bucuresti, Ilf, Giurgiu, Teleorman, Prahova, Dambovita, Calarasi (partial), Ialomita (partial)",
    codes: ["B", "IF", "GR", "TR", "PH", "DB", "CL", "IL"],
    centerDot: mapNodes["Bucuresti"],
    arrows: {
      topLeft: true,
      topRight: true,
      bottomLeft: true,
      bottomRight: true,
    },
    contact: "Marian MANEA / bucuresti@ahead-translog.ro / 0728 220 168",
  },
  {
    nod: "Buzau",
    zona: "BZU",
    arie: "Buzau, Vrancea, Galati, Braila, Ialomita (partial)",
    codes: ["BZ", "VN", "GL", "BR", "IL"],
    centerDot: mapNodes["Buzau"],
    arrows: { topLeft: true, bottomRight: true },
    contact: "Marius ANTON / buzau@ahead-translog.ro / 0748 842 828",
  },
  {
    nod: "Cluj",
    zona: "CLJ",
    arie: "Cluj, Salaj, Mures, Bistrita-Nasaud",
    codes: ["CJ", "SJ", "MS", "BN"],
    centerDot: mapNodes["Cluj"],
    arrows: { topLeft: true, bottomRight: true },
    contact: "Alex JIENARU / cluj@ahead-translog.ro / 0748 916 159",
  },
  {
    nod: "Constanta",
    zona: "CTA",
    arie: "Constanta, Tulcea, Ialomita (partial), Calarasi (partial)",
    codes: ["CT", "TL", "IL", "CL"],
    centerDot: mapNodes["Constanta"],
    arrows: { topLeft: true },
    contact: "Claudiu CRETU / constanta@ahead-translog.ro / 0748 958 376",
  },
  {
    nod: "Craiova",
    zona: "CRV",
    arie: "Dolj, Olt, Arges, Valcea, Mehedinti, Gorj",
    codes: ["DJ", "OT", "AG", "VL", "MH", "GJ"],
    centerDot: mapNodes["Craiova"],
    arrows: { topLeft: true, topRight: true },
    contact: "Stefan VASILE / craiova@ahead-translog.ro / 0771 243 512",
  },
  {
    nod: "Miercurea – Ciuc",
    zona: "MRC",
    arie: "Harghita, Covasna, Brasov (doar orasul)",
    codes: ["HR", "CV", "BV"],
    centerDot: mapNodes["Miercurea – Ciuc"],
    arrows: { topLeft: true, bottomLeft: true, bottomRight: true },
    contact: "Alex BICIAGA / roman@ahead-translog.ro / 0743 633 153",
  },
  {
    nod: "Oradea",
    zona: "BIH",
    arie: "Bihor",
    codes: ["BH"],
    centerDot: mapNodes["Oradea"],
    arrows: { bottomRight: true },
    contact: "Alex JIENARU / cluj@ahead-translog.ro / 0748 916 159",
  },
  {
    nod: "Orastie",
    zona: "ORS",
    arie: "Hunedoara, Timisoara, Arad, Alba, Sibiu, Caras-Severin (partial)",
    codes: ["HD", "TM", "AR", "AB", "SB", "CS"],
    centerDot: mapNodes["Orastie"],
    arrows: { topLeft: true, bottomLeft: true, bottomRight: true },
    contact: "Robert GHEORGHEONI / orastie@ahead-translog.ro / 0773 883 129",
  },
  {
    nod: "Neamt",
    zona: "RMN",
    arie: "Suceava, Botosani, Iasi, Neamt, Bacau, Vaslui",
    codes: ["SV", "BT", "IS", "NT", "BC", "VS"],
    centerDot: mapNodes["Neamt"],
    arrows: { bottomLeft: true, bottomRight: true },
    contact: "Alex BICIAGA / roman@ahead-translog.ro / 0743 633 153",
  },
  {
    nod: "Valea Chioarului",
    zona: "VCH",
    arie: "Satu Mare, Maramures",
    codes: ["SM", "MM"],
    centerDot: mapNodes["Valea Chioarului"],
    arrows: { bottomRight: true },
    contact: "Alex JIENARU / cluj@ahead-translog.ro / 0748 916 159",
  },
];

export const mapRoutes = [
  // Cluj
  {
    from: { nod: "Cluj", ...mapNodes.Cluj },
    to: { nod: "ValeaChioarului", ...mapNodes["Valea Chioarului"] },

    via: [
      mapNodes.Maramures, // Maramureș
    ],
  },
  {
    from: { nod: "Cluj", ...mapNodes.Cluj },
    to: { nod: "Oradea", ...mapNodes.Oradea },
  },
  {
    from: { nod: "Cluj", ...mapNodes.Cluj },
    to: { nod: "Orastie", ...mapNodes.Orastie }, // Hunedoara = Orastie
    via: [mapNodes.Alba],
  },
  // Orastie
  {
    from: { nod: "Orastie", ...mapNodes.Orastie }, // Hunedoara
    to: { nod: "Craiova", ...mapNodes.Craiova }, // Dolj
    via: [mapNodes.Gorj],
  },
  // Bucuresti
  {
    from: { nod: "Bucuresti", ...mapNodes.Bucuresti },
    to: { nod: "Craiova", ...mapNodes.Craiova },
    via: [
      { x: 360, y: 340 },
      { x: 290, y: 310 },
      { x: 270, y: 360 },
      { x: 250, y: 370 },
    ],
  },
  {
    from: { nod: "Bucuresti", ...mapNodes.Bucuresti },
    to: { nod: "Constanta", ...mapNodes.Constanta },
    via: [mapNodes.Calarasi],
  },
  {
    from: { nod: "Bucuresti", ...mapNodes.Bucuresti },
    to: { nod: "Miercurea – Ciuc", ...mapNodes["Miercurea – Ciuc"] },
    via: [mapNodes.Prahova, mapNodes.Brasov, mapNodes.Covasna],
  },
  {
    from: { nod: "Bucuresti", ...mapNodes.Bucuresti },
    to: { nod: "Buzau", ...mapNodes.Buzau },
    via: [mapNodes.Ialomita],
  },

  {
    from: { nod: "Buzau", ...mapNodes.Buzau },
    to: { nod: "Neamt", ...mapNodes.Neamt },
    via: [mapNodes.Vrancea, mapNodes.Bacau],
  },
];
